<template>
  <div class="d-inline dot" style="z-index: 97">
    <!-- :hover is not handled on the same way in all iOS devices. We therefore use the class active
    instead to hide/display the tooltips -->
    <fin-lexicon-text :class="'tooltiptext ' + (hovered? 'hovered ' : '')" auto-solve
                      :text="tooltipText"/>
    <button-active v-if="active" style="z-index: 98"/>
    <button-default v-else style="z-index: 98"/>
  </div>
</template>

<script>
import ButtonActive from './ButtonActive'
import ButtonDefault from './ButtonDefault'
import FinLexiconText from "../../../../../common/lexicon/LexiconText/index"

export default {
  name: 'FinStepByStepButton',
  components: {
    FinLexiconText,
    ButtonActive,
    ButtonDefault
  },
  props: {
    active: {
      type: Boolean
    },
    hovered: {
      type: Boolean
    },
    tooltipText: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../styles/variables";

div {
  cursor: pointer
}

/* Tooltip text */
.dot .tooltiptext {
  visibility: hidden;
  width: 370px;
  font-size: 16px;
  background-color: #FFFFFF;
  color: $fin-color-primary-dark;
  padding: 11px 10px 11px 13px;
  position: absolute;
  top: 50px;
  text-align: left;
  z-index: 1;
  box-shadow: $fin-color-shadow;
  border: solid 1px $fin-color-light-sky-blue;
}

/* Show the tooltip text when you mouse over the tooltip container */
.dot .tooltiptext.hovered, .dot .tooltiptext.active {
  visibility: visible;
}

#step1 {
  .btn_0 .tooltiptext {
    top: 60px;
    left: -150px;
  }

  .btn_1 .tooltiptext {
    top: -5px;
    left: 60px;
  }

  .btn_2 .tooltiptext {
    top: 64px;
    left: 20px;
  }
}

#step2 {
  .btn_0 .tooltiptext {
    top: -122px;
    right: -185px;
  }

  .btn_1 .tooltiptext {
    top: -40px;
    left: 59px;
  }

  .btn_2 .tooltiptext {
    top: -35px;
    right: 50px;
  }
}

#step3 {
  .btn_0 .tooltiptext {
    top: 60px;
    right: 15px;
  }

  .btn_1 .tooltiptext {
    top: -125px;
    right: 15px;
  }

  .btn_2 .tooltiptext {
    top: -100px;
    right: 30px;
  }
}

#step4 {
  .btn_0 .tooltiptext {
    top: 55px;
    left: -155px;
    width: 410px
  }

  .btn_1 .tooltiptext {
    top: 45px;
    right: 55px;
    width: 430px
  }

  .btn_2 .tooltiptext {
    right: 53px;
  }
}

#step5 {
  .btn_0 .tooltiptext {
    top: 17px;
    left: 63px;
    width: 550px;
  }

  .btn_1 .tooltiptext {
    top: 10px;
    right: 53px;
    width: 200px;
  }

  .btn_2 .tooltiptext {
    top: 50px;
    right: 60px;
  }
}

#step6 {
  .btn_0 .tooltiptext {
    top: -145px;
    left: 56px;
  }

  .btn_1 .tooltiptext {
    top: -145px;
    left: 20px;
  }

  .btn_2 .tooltiptext {
    top: -65px;
    right: 60px;
    width: 620px;
  }
}

</style>
